/* eslint-disable no-continue */
/* eslint-disable no-prototype-builtins */
/* eslint-disable func-names */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from 'src/api/api-client';
import {
  getIntroductionURI,
  getCustomerCategoryURI,
  updateStatusIntroductionStatusURI,
  detailIntroductionURI,
  updateIntroductionStatusURI,
  uploadFileURI,
} from '../api';
import { setDefaultValue } from './IntroductionItemSlice';
import { setValue } from './MessageSlice';

// First, create the thunk
export const fetchIntroductions = createAsyncThunk(
  'introduction/fetchIntroductions',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${getIntroductionURI}`,
          params: { ...params, get_all: true },
        })
        .then(res => res.data);
      return response.data;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const detailIntroduction = createAsyncThunk(
  'introduction/detailIntroduction',
  async (id, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${detailIntroductionURI(id)}`,
        })
        .then(res => res.data);
      dispatch(
        setDefaultValue({
          ...response.data,
        }),
      );
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const updateStatusIntroduction = createAsyncThunk(
  'introduction/detailIntroduction',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient.handleRequest({
        method: 'post',
        url: `${updateStatusIntroductionStatusURI(data.id)}`,
        data: { ...data, status: data.status === 'inactive' ? 'active' : 'inactive' },
      });
      dispatch(fetchIntroductions({ page: 1 }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const upsertIntroduction = createAsyncThunk(
  'introduction/upsertIntroduction',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient.handleRequest({
        method: 'post',
        url: `${updateIntroductionStatusURI(data.id)}`,
        data: data.data,
      });
      if (data.id) {
        dispatch(setValue({ show: true, body: 'Cập nhật thành công', color: 'success' }));
      } else {
        dispatch(setValue({ show: true, body: 'Tạo mới thành công', color: 'success' }));
      }

      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const deleteIntroduction = createAsyncThunk(
  'introduction/deleteIntroduction',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'delete',
          url: `${updateIntroductionStatusURI(data.id)}`,
        })
        .then(res => res.data);
      dispatch(fetchIntroductions({ page: 1 }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const uploadBanner = createAsyncThunk(
  'introduction/uploadFile',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'post',
          url: uploadFileURI,
          data: data.data,
        })
        .then(res => res.data);
      const dataCurrent = getState().introductionItem;
      dispatch(setDefaultValue({ ...dataCurrent, banner_url: response }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
export const uploadOurPartner = createAsyncThunk(
  'introduction/uploadOurPartner',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'post',
          url: uploadFileURI,
          data: data.data,
        })
        .then(res => res.data);
      const dataCurrent = getState().introductionItem;
      dispatch(
        setDefaultValue({ ...dataCurrent, our_partner: [...dataCurrent.our_partner, response] }),
      );
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const uploadOurCustomer = createAsyncThunk(
  'introduction/uploadOurCustomer',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'post',
          url: uploadFileURI,
          data: data.data,
        })
        .then(res => res.data);
      const dataCurrent = getState().introductionItem;
      const dataOurCustomer = [...getState().introductionItem.our_customer];
      const addImage = [...dataOurCustomer[data.index].image, response];
      dataOurCustomer[data.index] = { ...dataOurCustomer[data.index], image: addImage };
      dispatch(
        setDefaultValue({
          ...dataCurrent,
          our_customer: dataOurCustomer,
        }),
      );
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const getCategoryIntroduction = createAsyncThunk(
  'introduction/getCategoryIntroduction',
  async (params, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: getCustomerCategoryURI,
          params: { ...params, get_all: true },
        })
        .then(res => res.data);
      return response;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
export const insertCategoryIntroduction = createAsyncThunk(
  'introduction/insertCategoryIntroduction',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'post',
          url: getCustomerCategoryURI,
          data: { name: data.data, name_jp: data.dataJP, status: 'active' },
        })
        .then(res => res.data);
      dispatch(getCategoryIntroduction());
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
// Then, handle actions in your reducers:
const introductionSlice = createSlice({
  name: 'introduction',
  initialState: {
    entities: [],
    loading: 'idle',
    saving: 'idle',
    currentRequestId: undefined,
    error: null,
    currentPage: 1,
    totalPage: 1,
    total: 0,
    customerCategoryList: [],
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchIntroductions.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchIntroductions.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { data, last_page, current_page, total } = action.payload;
        state.loading = 'idle';
        state.entities = data;
        state.currentPage = current_page;
        state.totalPage = last_page;
        state.currentRequestId = undefined;
        state.total = total;
      }
    },
    [fetchIntroductions.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [getCategoryIntroduction.fulfilled]: (state, action) => {
      const { data, last_page, current_page, total } = action.payload;
      state.loading = 'idle';
      state.customerCategoryList = data;
    },
  },
});

export default introductionSlice.reducer;
